module.exports = __webpack_public_path__ + "static/world-around-8914d035ef96a1af60ab399d5c395457.svg";